function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

document.querySelectorAll('.closeSVG').forEach((close) => {

  close.addEventListener('click', (event) => {
    document.querySelectorAll('.custom-banner').forEach( image  => {
      image.classList.remove('actives')
    });
  })

})
document.querySelectorAll('.header_close').forEach( x  => {
  x.addEventListener('click', (event) => {
    document.querySelectorAll('.custom-banner').forEach( image  => {
      image.classList.remove('actives')
    });
  })
});
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
 
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    
    if(event.currentTarget.classList.contains('link--child')){
      closeAll(event)

    }
   
    else{
      let parentTarget = event.currentTarget
      if(event.currentTarget.classList.contains('parent-menu-item')){
        if( parentTarget.parentNode.getAttribute('open') === null ){
          let bg = event.currentTarget.getAttribute('data-bg');
          if(bg){
            document.querySelectorAll('.custom-banner').forEach( image  => {
              image.style.backgroundImage = "url("+bg+")"; 
              image.classList.add('actives')
            });
            
          }
        }else{
          document.querySelectorAll('.custom-banner').forEach( image  => {
            if(image.classList.contains('actives'))image.classList.remove('actives')
          });
        }
      }
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
function closeAll(e){
  document.querySelectorAll('[id^="Details-"] summary.link--child').forEach((summary) => {
    if(e.currentTarget === summary){
    e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
   
    }else{
      summary.setAttribute('aria-expanded', false);
      summary.parentNode.removeAttribute('open')
      
     
    }

  });

  
  
}
function closeAllParent(e){
  document.querySelectorAll('[id^="Details-"] summary.link--parent').forEach((summary) => {
    if(e.currentTarget === summary){
    e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
   
    }else{
      summary.setAttribute('aria-expanded', false);
      summary.parentNode.removeAttribute('open')
      
     
    }

  });

  
  
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {

    this.querySelectorAll('details.menu-drawer-container.custom-new-drawer').forEach(summary => summary.addEventListener('mouseenter', this.onDetailsHover.bind(this)));
    this.querySelectorAll('summary.header__icon').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
     this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    
    this.querySelectorAll('details.menu-drawer-container.custom-new-drawer').forEach(summary => summary.addEventListener('mouseleave', this.onDeatilsLeave.bind(this)));
   
    //this.querySelectorAll('details.menu-drawer-container.custom-new-drawer .menu-drawer').forEach(button => button.addEventListener('mouseleave', this.onDrawerLeave.bind(this)));
    /*this.querySelectorAll('summary.menu__item__heading').forEach(item => item.addEventListener('mouseover', this.onItemClick.bind(this)));
   
    this.querySelectorAll('a.menu__item__link').forEach(al => al.addEventListener('mouseover', this.onItemClickLink.bind(this)));*/

  }
  
  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onDetailsHover(event) {
    /*document.querySelectorAll('details.menu-drawer-container.custom-new-drawer').forEach(summary =>{
     const isOpen = summary.hasAttribute('open');
      if(isOpen && summary !== event.currentTarget) {
        summary.removeAttribute('open')
        summary.classList.remove('menu-opening');
      }
    });*/
    const detailsElement = event.currentTarget;
    const summaryElement = detailsElement.querySelector('summary');

    const isOpen = detailsElement.hasAttribute('open');

      if(isOpen) event.preventDefault();
      if (!isOpen){
        if(!detailsElement.hasAttribute('open')) detailsElement.setAttribute('open', '');
        this.openMenuDrawer(summaryElement);
      }

  }
  onDeatilsLeave(event){  
    
    this.closeMenuDetails(event)
  }

  onDrawerLeave(event){
    const drawer = event.currentTarget;
    const detailsElement = drawer.parentNode;
    const summaryElement = detailsElement.querySelector('summary');
    const rectDrawer = drawer.getBoundingClientRect();
    const rectSummary = summaryElement.getBoundingClientRect();

    if(event.clientY < rectDrawer.top){
      if(event.clientX > rectSummary.left && event.clientX < rectSummary.right){
      }else{
        this.closeMenuDetails(event)
        
      }
    }else{
      this.closeMenuDetails(event)
    }
  }

  closeBanner(event){
    this.querySelectorAll('.custom-banner').forEach( image  => {
      image.classList.remove('active')
    });   
  
  }
  closeBannerLink(event){
    this.querySelectorAll('.custom-banner-link').forEach( image  => {
      image.classList.remove('active')
    });
  }
  closeBannerCustom(event){
    this.querySelectorAll('.custom-banner').forEach( image  => {
      image.classList.remove('actives')
    });
  }
  onItemClickChild(event){
    
    this.closeBannerLink()
   
    this.querySelectorAll('summary.menu__item__child').forEach(item => {
      item.setAttribute('aria-expanded', false);
      item.parentNode.removeAttribute('open')
      item.parentNode.classList.remove('menu-opening')
    });
    const detailsElement = event.target.parentNode;
    detailsElement.classList.add('menu-opening')
    detailsElement.setAttribute('open','');
    event.target.setAttribute('aria-expanded', true);
  }

  onItemClickLink(event){

    if(event.target.tagName != 'svg' && event.target.tagName != 'path'){
      this.closeBanner()
      this.closeBannerCustom()
      this.closeBannerLink()
      this.querySelectorAll('summary.menu__item__heading').forEach(item => {
        item.setAttribute('aria-expanded', false);
        item.parentNode.removeAttribute('open')
        item.parentNode.classList.remove('menu-opening')
      });
   
      let bg = event.target.getAttribute('data-bg');
      if(bg){
        this.querySelectorAll('.custom-banner-link').forEach( image  => {
          image.style.backgroundImage = "url("+bg+")"; 
          image.classList.add('active')
        });
        
      }
  }
  }
  onItemClick(event){
    
    if(event.target.tagName != 'svg' && event.target.tagName != 'path'){
      this.closeBanner()
      this.closeBannerLink()
      this.querySelectorAll('summary.menu__item__heading').forEach(item => {
        item.setAttribute('aria-expanded', false);
        item.parentNode.removeAttribute('open')
        item.parentNode.classList.remove('menu-opening')
      });
 
      let bg = event.target.getAttribute('data-bg');
   
      if(bg){
       
        this.querySelectorAll('.custom-banner').forEach( image  => {
          image.style.backgroundImage = "url("+bg+")"; 
          image.classList.add('active')
        });

      }

        const detailsElement = event.target.parentNode;
      detailsElement.classList.add('menu-opening')
      detailsElement.setAttribute('open','');
      event.target.setAttribute('aria-expanded', true);
  }
    
  }
  onSummaryClick(event) {
    
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    
    if(!summaryElement.classList.contains('menu__item__child')){
      this.closeBanner()
      closeAllParent(event)
    }



    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      if (isOpen){
        this.closeMenuDrawer(event, summaryElement)
      }
      else{
        this.openMenuDrawer(summaryElement);
      }

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        if (window.matchMedia('(max-width: 990px)')) {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
        }
        //!reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }

 
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.closeBanner();
    this.closeBannerLink();
    /*this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });*/
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  closeMenuDetails(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.removeAttribute('open');
    /*this.closeBanner();
    this.closeBannerLink();
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });*/
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    //removeTrapFocus(elementToFocus);
    //this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    //summaryElement.setAttribute('aria-expanded', true);
    //trapFocus(this.mainDetailsToggle, summaryElement);
    //document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
 
    this.getAvailability()
    this.addEventListener('change', this.onVariantChange);
  }

  getAvailability(){
    this.updateOptions();
    this.updateMasterId();

    let variantTitle = this.currentVariant.option1
    let variantPrice = this.currentVariant.price
    let data = this.getVariantData()
    var formated = Shopify.formatMoney(variantPrice)
   
    let currentVariants = data.filter(v => { 
      return v.option1 === variantTitle
    }).map((option, index) => {
        return { id: option.id, availability: option.available, size: option.option2.toString(), quantity: option.inventory_quantity }
      });

  

    const radios = document.querySelectorAll('input[type="radio"][name="Size"]');
    
    const radiosColor = document.querySelectorAll('input[type="radio"][name="Color"]');
    if(radios){
      radios.forEach(radio => {
        radio.removeAttribute("disabled")
        radio.setAttribute('data-disabled',false)
        radio.removeAttribute("checked")
        
        let findValue = this.search(radio.value.toString(), currentVariants);
        if(findValue){
          if(findValue.availability === false){
            radio.setAttribute('data-disabled',true)
          }
        }

        if(radio.value.toString() === this.currentVariant.option2.toString() ){
          radio.checked = true
        }

        /* Change Variant ID of existen recently viewed product */
        let productvariantHandle = radio.getAttribute('data-handle')
        let variantIdpdp = currentVariants[0].id
        let arrayRecentProducts = JSON.parse(localStorage.getItem('viewed_products'))
        if(arrayRecentProducts){
          if(productvariantHandle && variantIdpdp){
            let data_counter = arrayRecentProducts.length
            let indexVariant = arrayRecentProducts.findIndex(p => p.handle == productvariantHandle);
            
            if( indexVariant >= 0){
                arrayRecentProducts[indexVariant].id = variantIdpdp
                localStorage.setItem('viewed_products', JSON.stringify(arrayRecentProducts))
            }else{
              if(data_counter < 6){
                arrayRecentProducts.push({
                    handle: productvariantHandle,
                    id: variantIdpdp
                })
                localStorage.setItem('viewed_products', JSON.stringify(arrayRecentProducts))
              }else{
                arrayRecentProducts = arrayRecentProducts.slice(1);
                arrayRecentProducts.push({
                    handle: productvariantHandle,
                    id: variantIdpdp
                })
                localStorage.setItem('viewed_products', JSON.stringify(arrayRecentProducts))
              }
            }
          }
        }else{
          if(productvariantHandle && variantIdpdp){
            let newArray = []
            newArray.push({
                handle: productvariantHandle,
                id: variantIdpdp
            })
            localStorage.setItem('viewed_products', JSON.stringify(newArray))
          }
        }

        
      });
    }

    if(radiosColor){
      radiosColor.forEach(color => {
        color.removeAttribute("checked")
        
        if(color.value === variantTitle){
          color.checked = true
        }
        
      });
    }
    let checkoutButton = document.getElementById('checkoutButton')
    if(this.currentVariant.available && checkoutButton) checkoutButton.innerHTML = 'Add to cart - '+formated
    if(this.currentVariant.available === true && (this.currentVariant.inventory_quantity > 0  && this.currentVariant.inventory_quantity <= 2)){
      document.getElementById('low-stock-warning').style.display = 'block';
      document.getElementById('low-stock-qty').innerHTML = this.currentVariant.inventory_quantity
    }else{
      document.getElementById('low-stock-warning').style.display = 'none';
    }
    
  }
   search(nameKey, myArray){
    for (let i=0; i < myArray.length; i++) {
        if (myArray[i].size === nameKey) {
            return myArray[i];
        }
    }
  }
  onVariantChange() {
    
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`.form`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      

      if(input) input.value = this.currentVariant.id;
    
      //input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.getAvailability();
  
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        if (this.currentVariant.available) {
          this.toggleAddButton(false);
        } else {
          const showCS = this.dataset.showComingSoonButton === 'true';
          const text = showCS ? 'COMING SOON' : window.variantStrings.soldOut;
          this.toggleAddButton(true, text);
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`.form`);
    if (!productForms) return;

    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const notifyBtn = productForm.querySelector('#custom-klaviyo-bis-trigger') || document.getElementById('custom-klaviyo-bis-trigger');
      const soldOutTag = productForm.querySelector('.sold-out-tag-wrapper');

      // Checkbox "Show 'Add to Cart' button" del editor: si está apagado,
      // el ATC queda oculto y Notify Me visible aunque la variante tenga stock.
      const atcHiddenByConfig = productForm.querySelector('[data-show-atc="false"]') !== null;
      const hideAtc = disable || atcHiddenByConfig;

      // El label de Sold Out / Coming Soon refleja el stock, no el checkbox
      if (soldOutTag) soldOutTag.style.display = disable ? 'block' : 'none';

      if (hideAtc) {
        // OCULTAR ADD TO CART Y MOSTRAR EL BOTÓN PROPIO DE NOTIFY ME
        addButton.style.setProperty('display', 'none', 'important');
        addButton.setAttribute('disabled', 'disabled');

        if (notifyBtn) notifyBtn.style.setProperty('display', 'block', 'important');

      } else {
        // SI HAY STOCK: MOSTRAR ADD TO CART Y OCULTAR NOTIFY ME
        addButton.style.setProperty('display', 'block', 'important');
        addButton.removeAttribute('disabled');

        if (notifyBtn) notifyBtn.style.setProperty('display', 'none', 'important');

        // Tu código normal de precios / Add to cart...
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (addButtonText && addButton.getAttribute("id") != 'checkoutButonMain') {
          let mainContainer = document.getElementById('custom-main-product__container');
          let variantPrice = this.currentVariant ? this.currentVariant.price : 0;
          let discountPrice = this.currentVariant ? this.currentVariant.compare_at_price : 0;
          var formated = Shopify.formatMoney(variantPrice);
          var formatedDiscount = Shopify.formatMoney(discountPrice);
          let discountHTML = '';

          if (discountPrice > 0) {
            discountHTML = `<span><s class="price-item price-item--regular custom-price"> ${formatedDiscount}</s></span> `;
          }

          if (mainContainer && mainContainer.classList.contains('ab_first_variant') && !mainContainer.classList.contains('ab_fourth_variant')) {
            addButtonText.innerHTML = window.variantStrings.addToCart + ' - ' + discountHTML + formated;
          } else {
            addButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const fieldsetsCustom = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

            let allColors = document.querySelectorAll('.colorlist label')
            var getData = function () {
              var parent =
                  this.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
              var get_selector = parent.getAttribute("data-selector");
              var get_color = this.getAttribute("data-opt-color");
              var handle = parent.getAttribute("data-product-handle");
              var limit = parent.getAttribute("data-id");
              
              let size_selector = document.querySelector(
                  '[data-selector="' +
                      get_selector +
                      '"][data-product-handle="' +
                      handle +
                      '"][data-id="' +
                      limit +
                      '"] [data-color-sizes="' +
                      get_color +
                      '"]'
              );
  
              var actives = parent.querySelectorAll(".active");
              [].forEach.call(actives, function (elem) {
                  elem.classList.remove("active");
              });
  
              if (size_selector) size_selector.classList.add("active");
              const price_selector = document.querySelector(
                  '[data-selector="' +
                      get_selector +
                      '"][data-product-handle="' +
                      handle +
                      '"][data-id="' +
                      limit +
                      '"] [data-color-price="' +
                      get_color +
                      '"]'
              );
              if (price_selector) price_selector.classList.add("active");
              const title_selector = document.querySelector(
                  '[data-selector="' +
                      get_selector +
                      '"][data-product-handle="' +
                      handle +
                      '"][data-id="' +
                      limit +
                      '"] [data-color-title="' +
                      get_color +
                      '"]'
              );
              if (title_selector) title_selector.classList.add("active");
              const img_selector = document.querySelector(
                  '[data-selector="' +
                      get_selector +
                      '"][data-product-handle="' +
                      handle +
                      '"][data-id="' +
                      limit +
                      '"] [data-color-imgs="' +
                      get_color +
                      '"]'
              );
              if (img_selector) img_selector.classList.add("active");
              const selectedAttr = document.querySelector(
                  '[data-selector="' +
                      get_selector +
                      '"][data-product-handle="' +
                      handle +
                      '"][data-id="' +
                      limit +
                      '"] [data-opt-color-selected="1"]'
              );
              if (selectedAttr) selectedAttr.setAttribute("data-opt-color-selected", "0");

              const selectedVariantId =
                  (price_selector && price_selector.getAttribute("data_id")) ||
                  this.getAttribute("data-opt-id");
              const relatedSelectors = [get_selector];
              if (get_selector.indexOf("pcpsecondary-") === 0) {
                  relatedSelectors.push(get_selector.replace("pcpsecondary-", "pcp-"));
              } else if (get_selector.indexOf("pcp-") === 0) {
                  relatedSelectors.push(get_selector.replace("pcp-", "pcpsecondary-"));
              }
              relatedSelectors.forEach((selectorName) => {
                  const selectorRoot =
                      '[data-selector="' +
                      selectorName +
                      '"][data-product-handle="' +
                      handle +
                      '"][data-id="' +
                      limit +
                      '"]';
                  const cardLink = document.querySelector(selectorRoot + " a.sizelist-wrap");
                  if (cardLink && selectedVariantId) {
                      const nextUrl = new URL(
                          cardLink.getAttribute("href"),
                          window.location.origin
                      );
                      nextUrl.searchParams.set("variant", selectedVariantId);
                      cardLink.setAttribute(
                          "href",
                          `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`
                      );
                  }
                  const scopedImageLink = document.querySelector(
                      selectorRoot +
                          ' [data-color-imgs="' +
                          get_color +
                          '"] .grid-product__image-link'
                  );
                  if (scopedImageLink && selectedVariantId) {
                      const nextImageUrl = new URL(
                          scopedImageLink.getAttribute("href"),
                          window.location.origin
                      );
                      nextImageUrl.searchParams.set("variant", selectedVariantId);
                      scopedImageLink.setAttribute(
                          "href",
                          `${nextImageUrl.pathname}${nextImageUrl.search}${nextImageUrl.hash}`
                      );
                  }
              });
  
              this.setAttribute("data-opt-color-selected", "1");
          };
            for (var i = 0; i < allColors.length; i++) {
            allColors[i].addEventListener('click', getData, false);
            }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


  document.addEventListener('DOMContentLoaded', function() {
    const notifyBtn = document.getElementById('custom-klaviyo-bis-trigger');

    if (notifyBtn) {
      notifyBtn.addEventListener('click', function(e) {
        e.preventDefault();

        // El trigger oculto que inyecta Klaviyo BIS abre el modal al hacerle clic,
        // aunque esté con display:none.
        const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger');

        if (klaviyoTrigger && klaviyoTrigger !== notifyBtn) {
          klaviyoTrigger.click();
        } else {
          console.warn('Klaviyo BIS aún no inicializado (script cargando o cookies de performance rechazadas).');
        }
      });
    }
  });
